import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, MapPin, ExternalLink, Send, CheckCircle } from 'lucide-react';

const Disponibilite = ({ data }) => {
  return (
    <section className="py-4 section-spacing">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="bg-gradient-to-r from-green-900/20 via-dark-surface to-violet-900/20 rounded-2xl p-8 border border-green-500/30 shadow-2xl relative overflow-hidden"
      >
        {/* Éléments décoratifs verts */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-green-600/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-emerald-600/10 rounded-full blur-3xl" />
        
        {/* Badge "Disponible" en vert */}
        <div className="absolute top-4 right-4">
          <span className="badge-available flex items-center gap-2">
            <CheckCircle size={16} />
            Disponible
          </span>
        </div>
        
        <div className="relative z-10 font-mono ">
          {/* Ligne de commande avec vert */}
          <div className="text-sm text-green-500 mb-4">$ ./status --available</div>
          
          {/* Première ligne */}
          <div className="flex items-start gap-4 mb-4">
            <div className="bg-green-600/20 p-3 rounded-full">
              <Briefcase className="text-green-400" size={24} />
            </div>
            <p className="text-xl md:text-2xl font-bold text-white">
              {data.ligne1}
            </p>
          </div>

          {/* Deuxième ligne - remote */}
          <div className="flex items-start gap-4 mb-4 ml-16">
            <MapPin className="text-green-400 flex-shrink-0" size={18} />
            <p className="text-base text-gray-300">
              {data.ligne2}
            </p>
          </div>

          {/* Troisième ligne - site freelance */}
          <div className="flex items-center gap-4 mb-4 ml-16 flex-wrap">
            <span className="text-gray-400 text-sm">{data.site}</span>
            <motion.a
              href={`https://${data.lien}`}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-green-600 to-emerald-600 px-4 py-2 rounded-full text-white font-semibold hover:shadow-lg hover:shadow-green-600/30 transition-all text-sm"
            >
              {data.lien}
              <ExternalLink size={14} />
            </motion.a>
          </div>

          {/* Quatrième ligne - call to action */}
          <div className="flex items-center gap-4 ml-16 mt-6 pt-4 border-t border-green-500/20">
            <Send className="text-green-400" size={18} />
            <p className="text-base text-green-400 font-semibold">
              {data.cta}
            </p>
          </div>

          {/* Résultat style terminal avec vert */}
          <div className="mt-4 text-xs text-gray-500 flex items-center gap-2">
            <span className="text-green-400 animate-pulse">●</span>
            <span className="text-green-400">Status:</span> Disponible - Taux de réponse: 100%
          </div>
          <div className="mt-1 text-xs text-gray-500 flex items-center gap-2">
            <span className="text-green-400">✓</span>
            Prêt à démarrer votre projet
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Disponibilite;